import type { PropsWithChildren } from "react";

import { useTranslate } from "@similarweb/i18n-provider";
import { Flex, Text } from "@similarweb/ui-components/foundations";

export const FiltersContainer = ({ children }: PropsWithChildren) => {
    const { translate } = useTranslate();

    return (
        <Flex
            gap="16px"
            alignItems="center"
        >
            <Text fontVariant="chip1">{translate("activation.alerts.filters.filter.by")}</Text>
            {children}
        </Flex>
    );
};
